// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-player-persistent[data-v-3d35bc4f]{position:fixed;bottom:8px;right:8px;left:8px;z-index:5}.w-player-persistent .w-button-high-intensity[data-v-3d35bc4f]{z-index:10}.w-player-persistent--with-bottom-nav[data-v-3d35bc4f]{bottom:64px!important}.w-player-persistent--mobile .v-list__tile[data-v-3d35bc4f]{padding:0 4px}.w-player-persistent--mobile .v-list__tile__avatar[data-v-3d35bc4f]{min-width:46px}", ""]);
// Exports
module.exports = exports;
